import firebase from "firebase/app";
import useSWR from "swr";

export type DashboardEventTicketIds = {
  eventId: string;
  ticketIds: string[];
};

const GetDashboardEventTicketIdsKey = "getDashboardEventTicketIds";

/**
 * チェックイン確認ダッシュボードの導線に必要なチケットIDをイベント単位で取得する。
 * 呼び出し元でチケット閲覧権限を持つイベントだけに絞り、未ログイン時は取得しない。
 */
export const useGetDashboardEventTicketIds = (eventIds: string[]) => {
  const currentUserId = firebase.auth().currentUser?.uid ?? null;
  const uniqueEventIds = Array.from(new Set(eventIds)).sort();
  const uniqueEventIdsKey = JSON.stringify(uniqueEventIds);

  const {
    data: eventTicketIds = [],
    isLoading,
    isValidating,
    error,
    mutate,
  } = useSWR<DashboardEventTicketIds[], Error>(
    currentUserId && uniqueEventIds.length > 0
      ? [GetDashboardEventTicketIdsKey, currentUserId, uniqueEventIdsKey]
      : null,
    async () =>
      Promise.all(
        uniqueEventIds.map(async (eventId) => {
          const snapshot = await firebase
            .firestore()
            .collection(`tickets/${eventId}/tickets`)
            .get();

          return {
            eventId,
            ticketIds: snapshot.docs.map((document) => document.id).sort(),
          };
        })
      )
  );

  return {
    eventTicketIds,
    isLoading,
    isValidating,
    error,
    mutate,
  };
};
